export function SET_ACTIVITIES({ commit }, [activities]) {
    commit('SAVE_ACTIVITIES', [activities])
}

export function SET_DOWNLOADING({ commit }, [downloading]) {
    commit('SAVE_DOWNLOADING', [downloading])
}